invHdApp.controller('SupportController', ['$scope', 'Analytic', 'Account', '$location', 'FileUploader', '$http', '$rootScope',
	function ($scope, Analytic, Account, $location, FileUploader, $http, $rootScope) {

		$scope.filterProp = [];

		$scope.filterData = {
			export: false,
			customers: [],
			workers: [],
			workSteps: [],
			page: 1,
			date_type: 'cargo_date',
			scheduled_time: {
				startDate: null,
				endDate: null
			},
		}

		$scope.$on('refresh_data', function () {
			console.log('refreshing order reports...')
			$scope.init();
		}, true);

		$scope.$on('update_support', function () {
			console.log('refreshing order reports...')
			$scope.init();
		}, true);

		$scope.clearFilter = function (page) {
			$scope.filterData = {
				export: false,
				customers: [],
				workers: [],
				workSteps: [],
				page: 1,
				created_at: {
					startDate: null,
					endDate: null
				},
				scheduled_time: {
					startDate: null,
					endDate: null
				}
			}
		}

		$scope.init = function (type) {
			Analytic.support($scope.filterData).success(function (data, status, headers, config) {
				$scope.data = data;
				$scope.typeId = $scope.data.types[0].id;
				$scope.getOrders($scope.typeId);
			});
		};
		
		$scope.getOrders = function(type_id, support_status = null) {
			if(type_id) { 
				$scope.typeId = type_id;
				$scope.filterData.type_id = type_id;
			}
			if(support_status) {
				$scope.filterData.support_status = support_status
			}
			Analytic.supportOrders($scope.filterData).success(function (data, status, headers, config) {
				$scope.orders = data.orders;
			});
		}

		$scope.getPage = function (page) {
			$scope.filterData.page = page;
			$scope.filter();
		}

		$scope.export = function (page) {
			$scope.filterData.export = true;
			$scope.init('export');
		}

		$scope.sort = function (field, sort) {
			$scope.filterData.field = field;
			$scope.filterData.sort = sort;
			$scope.filter();
		}

		$scope.filter = function (type) {
			if (type == 'clear') {
				$scope.filterData = {
					export: false,
					customers: [],
					workers: [],
					workSteps: [],
					page: 1,
					created_at: {
						startDate: null,
						endDate: null
					},
					scheduled_time: {
						startDate: null,
						endDate: null
					}
				}
			}
			$scope.getOrders();
		}

	}
]);
